import React, { useCallback } from 'react';
import styled from 'styled-components';
import { newPopup as Popup } from '@sunbit-dev/web-ui-lib';
import * as styles from './styles';
import { ErrorModalProps } from './models';
import { PopupWrapper } from '@sunbit-dev/purchase-common/src/components/popup/Popup';
import classNames from 'classnames';
import { PrivacyAllowanceLayer } from '@sunbit-dev/purchase-common/src/components/privacyAllowanceLayer/PrivacyAllowanceLayer';
import messageService from '~/services/MessageService';
import { useSelector } from 'react-redux';
import { getStore } from '~/store/reducers/errors/errors';
import * as purchaseStore from '~/store/reducers/purchase/purchase';
import { isEmbeddedMode } from '@sunbit-dev/purchase-common/src/helpers/embeddedMode';
import { errorsMetaData } from '../errorBoundaries/constants';
import { getPrequalOriginFromSearch, hrefForReferer } from '~/helpers/referer';
import { useLocation } from 'react-router-dom';
import { ErrorCodes } from '~/enums/Errors';

export const ErrorModal = styled(({ className, id, texts, dataTestId, onClose: _onClose, error }: ErrorModalProps) => {
  const errorsState = useSelector(getStore);
  const currentError = errorsState.errors?.find((err) => err.id === id) || error;
  const { referer } = useSelector(purchaseStore.getStore);
  const { search } = useLocation();

  const errorCode = currentError?.payload?.code;
  const showRefreshButton = errorCode && errorsMetaData[errorCode]?.showRefreshButton;

  const onClose = useCallback(async () => {
    _onClose?.(id);
    if (errorCode === ErrorCodes.PurchaseAmountLimit || errorCode === ErrorCodes.LinkCreationError) {
      if (isEmbeddedMode()) {
        // relevant only for LoanApplicationOrigin.ONLINE_SDK but we don't know the origin at this point
        messageService.messageUserCancel();
      }
      if (referer) {
        window.location.href = hrefForReferer(referer, getPrequalOriginFromSearch(search));
      }
    }
    if (showRefreshButton) {
      window.location.reload();
    }
  }, [id, _onClose, errorCode, showRefreshButton, referer, search]);

  return (
    <PopupWrapper>
      <PrivacyAllowanceLayer>
        <Popup
          dataTestId={dataTestId}
          className={classNames(className, 'error-modal')}
          blueButtonAction={onClose}
          blueButtonText={texts?.button}
          boldText={texts?.title}
          onClose={onClose}
          noLightBox
        >
          <div className="error-content-text">
            {!!texts?.subtitle && <h2>{texts?.subtitle}</h2>}
            {!!texts?.description && <h4>{texts?.description}</h4>}
            {!!texts?.help && <h6>{texts?.help}</h6>}
          </div>
        </Popup>
      </PrivacyAllowanceLayer>
    </PopupWrapper>
  );
})`
  ${styles.ErrorModal}
`;
